<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">Internal Settings</div>
    </div>
    <div class="col-md-12 well-content">
        <table class="table one-column-emphasis">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Value</th>
                    <th>
                        @if (false) {
                            <button
                                type="button"
                                [routerLink]="['/configure/internalsettingcreate']"
                                class="btn btn-default"
                                aria-disabled="false"
                                (click)="openCreateModal()">
                                Create
                            </button>
                        }
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (setting of list; track setting) {
                    <tr>
                        <td>
                            {{ setting.KeyName }}
                        </td>
                        <td style="word-wrap: break-word; min-width: 160px; max-width: 160px">
                            {{ setting.IsBoolean ? (setting.BoolValue ? "Enabled" : "Disabled") : setting.KeyValue }}
                        </td>
                        <td>
                            <div class="tableRollover">
                                <button
                                    [routerLink]="['/configure/internalsettingedit']"
                                    [queryParams]="{id: setting.KeyID}"
                                    class="btn btn-default">
                                    Modify
                                </button>
                            </div>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
